import { render, staticRenderFns } from "./StepIOSExtendedNotification.vue?vue&type=template&id=0ff17a7f&scoped=true&"
import script from "./StepIOSExtendedNotification.vue?vue&type=script&lang=js&"
export * from "./StepIOSExtendedNotification.vue?vue&type=script&lang=js&"
import style0 from "./StepIOSExtendedNotification.vue?vue&type=style&index=0&id=0ff17a7f&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff17a7f",
  null
  
)

export default component.exports